import '../../vendor/jquery.vimeo.api';
import '../../vendor/player';

export default {
	init() {
		$('.listPost-img').on('click', function () {
			const videoUrl = $(this).parent('.listPost-listItem').data('video');
			const modal = `
            <div class="popinPostVideo" style="display:none">
                <div class="popinPostVideo-close"></div>
                <div class="popinPostVideo-content" id="popinVideo"></div>
            </div>
            `;
			const windowWidthMobile = $(window).width() < 768 || false;
			const options = {
				url: videoUrl,
				width: windowWidthMobile ? 800 : 1920,
				playsinline: windowWidthMobile ? false : true,
				autoplay: true,
			};

			$(modal).appendTo('.listPost');
			const id = $('.listPost').find('#popinVideo');

			const videoPlayer = new Vimeo.Player(id, options);

			$('.listPost').find('.popinPostVideo').fadeIn(1000);

			$('html').addClass('popup');
		});

		$(document).on('click', function (e) {
			if (
				$(e.target).hasClass('popinPostVideo-content') ||
				$(e.target).hasClass('popinPostVideo-close')
			) {
				$('.popinPostVideo').fadeOut(400, function () {
					$('html').removeClass('popup');
					$(this).remove();
				});
			}
		});
	},
};
